import {connect as reactReduxConnect} from 'react-redux';
import {STORE_CONTEXT} from '../constants/redux';

export const connect = (mapStateToProps, mapDispatchToProps, mergeProps, options = {}) => {
  options.context = STORE_CONTEXT;
  return reactReduxConnect(mapStateToProps, mapDispatchToProps, mergeProps, options);
};
